import { SessionVisibility } from "@swiggy-private/checkout-core";
import { LOCAL_STORAGE_KEYS } from "@swiggy-private/core-ui";

export const getTurboTooltipViewFreqCappPayload = (key?: string, maxViewFrequency?: number) => {
    return {
        id: "TURBO_TOOLTIP_VIEW_FREQUENCY_CAPPING_ID",
        key: `${LOCAL_STORAGE_KEYS.TURBO_TOOLTIP_VIEW_FREQUENCY_CAPPING_KEY}_${key || ""}`, //fallback to generic tooltip if key is not provided
        sessionVisibility: SessionVisibility.ONCE_PER_SESSION,
        maxFrequency: maxViewFrequency ?? 3,
    };
};
